/**
 * 必須
 */
export default (val, msg) => {
  if (val === undefined || val === null) {
    return msg
  }
  if (!val) {
    return msg
  }

  return true
}
